import { render, staticRenderFns } from "./SecondsDisplayField.vue?vue&type=template&id=99455142&scoped=true&"
import script from "./SecondsDisplayField.vue?vue&type=script&lang=js&"
export * from "./SecondsDisplayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99455142",
  null
  
)

export default component.exports